import styled from 'styled-components';
export const Wrapper = styled.div `
  width: 100%;
  position: absolute;
  top: 100%;
  left: 0;
  background: var(--color-neutral-130);
  transition: opacity ease 1s;
  opacity: 0;
  height: calc(100vh - 100%);
  pointer-events: none;

  &[data-open='true'] {
    overflow-y: auto;
    opacity: var(--opacity-semiopaque);
    pointer-events: all;
  }

  @media all and (min-width: 840px) {
    display: none;
  }
`;
